import { Fragment } from "react";
import { Link } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import NoDataFound from "../../../../Components/NoDataFound/NoDataFound";
import HolidaysListingViewModel from "./HolidaysListingViewModel";

const HolidaysListing = () => {
  const { HolidaysArray, IsLoading, AuthUser } = HolidaysListingViewModel();
  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper admin-holidays-listing-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Holidays</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={`/user/${AuthUser?.UserType}/dashboard`}>
                      Dashboard
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">Holidays</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="page-title">Holidays</h3>
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  {IsLoading ? (
                    <PulseLoader
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      color="#3D5EE1"
                      size={16}
                    />
                  ) : (
                    <div className="table-responsive">
                      <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                        <thead className="student-thread">
                          <tr>
                            <th>ID</th>
                            <th>Holiday Name</th>
                            <th>Type</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {HolidaysArray &&
                            HolidaysArray.map((item, index) => {
                              // Holidays Name Start
                              const ArrayOfHolidaysWords =
                                item?.HolidaysName.split(" ");
                              for (
                                var i = 0;
                                i < ArrayOfHolidaysWords.length;
                                i++
                              ) {
                                ArrayOfHolidaysWords[i] =
                                  ArrayOfHolidaysWords[i]
                                    .charAt(0)
                                    .toUpperCase() +
                                  ArrayOfHolidaysWords[i].slice(1);
                              }
                              const StringOfHolidaysWords =
                                ArrayOfHolidaysWords.join(" ");
                              // Holidays Name End

                              // Holidays Type Start
                              const ArrayOfTypeOfHolidaysWords =
                                item?.HolidaysType.split(" ");
                              for (
                                var j = 0;
                                j < ArrayOfTypeOfHolidaysWords.length;
                                j++
                              ) {
                                ArrayOfTypeOfHolidaysWords[j] =
                                  ArrayOfTypeOfHolidaysWords[j]
                                    .charAt(0)
                                    .toUpperCase() +
                                  ArrayOfTypeOfHolidaysWords[j].slice(1);
                              }
                              const StringOfTypeOfHolidaysWords =
                                ArrayOfTypeOfHolidaysWords.join(" ");
                              // Holidays Type End

                              return (
                                <tr key={index}>
                                  <td>{item?.HolidaysID}</td>
                                  <td>{StringOfHolidaysWords}</td>
                                  <td>{StringOfTypeOfHolidaysWords}</td>
                                  <td>{item?.HolidaysStartDate}</td>
                                  <td>{item?.HolidaysEndDate}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                      {HolidaysArray?.length <= 0 && <NoDataFound />}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default HolidaysListing;
